import React from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const Next = (props) => {
  const { currentPage, onChange, totalPages } = props;
  const { t } = useLocalization();

  const isDisabled = currentPage >= totalPages;

  const handleOnClick = () => {
    onChange(currentPage + 1);
  };

  return (
    <li className="c7-pagination__arrow">
      <button
        className="c7-link"
        type="button"
        disabled={isDisabled}
        onClick={handleOnClick}
      >
        <span className="c7-sr-only">
          {t('general.accessibility.nextPage')}
        </span>
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </li>
  );
};

export default Next;
